<template>
  <v-main v-if="isFound">
    <v-alert id="alert" v-model="alert.isAlert" :type="alert.type" closable class="row">{{ alert.message }}</v-alert>
    <v-overlay :model-value="showOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div id="pdf-container">
      <v-container fluid>
        <h1>開通情報</h1>
      </v-container>
      <v-container fluid>
        <v-card>
          <v-table density="compact">
            <template #default>
              <tbody>
                <template v-if="opening.opening_type == openingType.message">
                  <tr>
                    <td>製品</td>
                    <td id="serviceName">{{ opening.profile_productgroup_name }}</td>
                  </tr>
                  <tr>
                    <td>利用区分</td>
                    <td id="accoutType">{{ opening.profile_usagetype_name }}</td>
                  </tr>
                  <tr>
                    <td>お客様名</td>
                    <td id="customerName">{{ opening.profile_customer_name }}</td>
                  </tr>
                  <tr>
                    <td>プロファイルID</td>
                    <td id="profileId">{{ opening.profile_id }}</td>
                  </tr>
                  <template v-if="opening.rcs_nickname != null">
                    <tr>
                      <td>ニックネーム</td>
                      <td id="rcsNickname">{{ opening.rcs_nickname }}</td>
                    </tr>
                  </template>
                  <template v-if="opening.profile_apiaccesskey != null">
                    <tr>
                      <td>APIアクセスキー</td>
                      <td id="apiAccessKey">{{ opening.profile_apiaccesskey }}</td>
                    </tr>
                  </template>
                  <template v-if="opening.combined_number_from != null">
                    <tr>
                      <td>送信元番号(ドコモ/au/楽天)</td>
                      <td id="combinedNumberFrom">{{ opening.combined_number_from }}</td>
                    </tr>
                  </template>
                  <template v-if="opening.softbank_from != null">
                    <tr>
                      <td>送信元番号(ソフトバンク)</td>
                      <td id="softbankFrom">{{ opening.softbank_from }}</td>
                    </tr>
                  </template>
                  <template v-if="opening.profile_start_date != null">
                    <tr>
                      <td>ご利用開始希望日</td>
                      <td id="profileStartDate">{{ opening.profile_start_date }}</td>
                    </tr>
                  </template>
                  <template v-if="opening.profile_end_date != null">
                    <tr>
                      <td>テスト終了日</td>
                      <td id="profileEndDate">{{ opening.profile_end_date }}</td>
                    </tr>
                  </template>
                  <template v-if="opening.login_url != null">
                    <tr>
                      <td>ログインURL</td>
                      <td id="loginUrl">
                        <a :href="opening.login_url" target="_blank" rel="noreferrer">
                          {{ opening.login_url }}
                        </a>
                      </td>
                    </tr>
                    <template v-for="item in opening.profile_account_list" :key="item.profile_account_id">
                      <tr class="separator">
                        <td colspan="2" class="separator"></td>
                      </tr>
                      <tr>
                        <td>ログインID</td>
                        <td name="loginId">{{ item.profile_account_id }}</td>
                      </tr>
                      <tr>
                        <td>{{ item.profile_account_password_title }}</td>
                        <td name="password">{{ item.profile_account_password }}</td>
                      </tr>
                    </template>
                  </template>
                  <template v-else>
                    <template v-for="item in opening.profile_account_list" :key="item.profile_account_id">
                      <tr class="separator">
                        <td colspan="2" class="separator"></td>
                      </tr>
                      <tr>
                        <td>管理画面URL</td>
                        <td name="loginUrl">
                          <a :href="item.login_url" target="_blank" rel="noreferrer">
                            {{ item.login_url }}
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>ログインID</td>
                        <td name="loginId">{{ item.profile_account_id }}</td>
                      </tr>
                      <tr>
                        <td>{{ item.profile_account_password_title }}</td>
                        <td name="password">{{ item.profile_account_password }}</td>
                      </tr>
                      <tr>
                        <td>識別コード</td>
                        <td name="lgwanCode">{{ item.lgwan_code }}</td>
                      </tr>
                    </template>
                  </template>
                  <template v-if="opening.profile_circuit_dial_tels != null">
                    <tr class="separator">
                      <td colspan="2" class="separator"></td>
                    </tr>
                    <tr>
                      <td>持ち込み番号</td>
                      <td name="profileCircuitDialTels">{{ opening.profile_circuit_dial_tels }}</td>
                    </tr>
                  </template>
                  <template v-if="opening.profile_ivr_tel != null">
                    <tr>
                      <td>IVR着信電話番号</td>
                      <td name="profileIvrTel">{{ opening.profile_ivr_tel }}</td>
                    </tr>
                  </template>
                  <template v-if="opening.profile_circuit_count >= 0">
                    <tr>
                      <td>回線数</td>
                      <td name="profileCircuitCount">{{ opening.profile_circuit_count }}</td>
                    </tr>
                  </template>
                </template>
                <template v-else-if="opening.opening_type == openingType.video">
                  <tr>
                    <td>サービス名</td>
                    <td id="serviceName">{{ opening.profile_productgroup_name }}</td>
                  </tr>
                  <tr>
                    <td>利用区分</td>
                    <td id="accountType">{{ opening.profile_usagetype_name }}</td>
                  </tr>
                  <tr>
                    <td>ご利用プラン</td>
                    <td id="useplan">{{ opening.profile_video_useplan }}</td>
                  </tr>
                  <tr>
                    <td>プロファイル名称</td>
                    <td id="profileName">{{ opening.profile_video_name }}</td>
                  </tr>
                  <tr>
                    <td>プロファイルID</td>
                    <td id="profileId">{{ opening.profile_video_id }}</td>
                  </tr>
                  <template v-if="opening.profile_video_apiaccesskey">
                    <tr>
                      <td>APIアクセスキー</td>
                      <td id="apiAccessKey">{{ opening.profile_video_apiaccesskey }}</td>
                    </tr>
                  </template>
                  <tr>
                    <td>ログインURL</td>
                    <td id="loginUrl">
                      <a :href="opening.login_url" target="_blank" rel="noreferrer">
                        {{ opening.login_url }}
                      </a>
                    </td>
                  </tr>
                  <template v-for="item in opening.profile_video_account_list" :key="item.profile_video_account_id">
                    <tr class="separator">
                      <td colspan="2" class="separator"></td>
                    </tr>
                    <tr>
                      <td>ログインID</td>
                      <td name="loginId">{{ item.profile_video_account_id }}</td>
                    </tr>
                    <tr>
                      <td>{{ item.profile_video_account_password_title }}</td>
                      <td name="password">{{ item.profile_video_account_password }}</td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </template>
          </v-table>
        </v-card>
      </v-container>
    </div>
    <template v-if="opening.opening_type">
      <v-col class="text-center">
        <div class="my-2">
          <v-btn id="downloadPdf" variant="flat" size="small" color="primary" @click="downloadPdf">PDFダウンロード</v-btn>
        </div>
      </v-col>
      <v-container fluid>
        <v-card>
          <v-card-text>
            <p class="text--primary">
              【ご留意事項】<br />
              ご契約のサービスはログインURLよりサービス提供サイトにログインする事でご利用いただけます。<br />
              操作マニュアルはログイン後の画面右上のメニューよりダウンロードください。
            </p>
          </v-card-text>
        </v-card>
      </v-container>
    </template>
  </v-main>
  <NotFound v-else />
</template>

<script>
import Api from '@/constants/api';
import JsPdfWrapper from '@/modules/JsPdfWrapper';
import NotFound from '@/views/NotFound';

export default {
  components: {
    NotFound,
  },
  props: {
    billingProfileId: {
      type: String,
    },
  },
  data: () => ({
    openingType: {
      message: 1,
      video: 2,
    },

    opening: {},
    alert: {
      isAlert: false,
      type: 'success',
      message: '',
    },
    showOverlay: false,
    isFound: true,
  }),

  created: async function () {
    this.showOverlay = true;
    try {
      await this.createOpening();
    } finally {
      this.showOverlay = false;
    }
  },

  methods: {
    createOpening: async function () {
      const billingProfileId = this.billingProfileId;
      const profileId = this.$route.query.profile_id;
      const accessToken = this.$cookies.get('access_token');
      console.log('billingProfileId=' + billingProfileId + ', profileId=' + profileId + ', accessToken=' + accessToken);

      let response = await this.axios.get(Api.PATH_OPENING + '/' + billingProfileId, {
        params: {
          profile_id: profileId,
        },
      });
      console.log(response);

      if (response.data.status == Api.STATUS_NOT_FOUND) {
        this.isFound = false;
      } else if (response.data.status == Api.STATUS_WARNING) {
        this.opening = {};
        this.showAlert('warning', response.data.error_message);
      } else if (response.data.status != Api.STATUS_SUCCESS) {
        this.opening = {};
        this.showAlert('error', '開通情報の取得に失敗しました。');
      }

      this.opening = response.data;
      console.log(this.opening);
    },

    showAlert: function (type, message) {
      this.alert.isAlert = true;
      this.alert.type = type;
      this.alert.message = message;
    },

    downloadPdf: async function () {
      this.showOverlay = true;
      try {
        const jsPdfWrapper = new JsPdfWrapper();
        const targetElement = document.getElementById('pdf-container');
        const fileName = '開通情報.pdf';
        await jsPdfWrapper.downloadFromHTML(targetElement, fileName, this.onClone);
      } finally {
        this.showOverlay = false;
      }
    },

    onClone: function (clonedDoc) {
      this.setStyle(clonedDoc, 'h1', 'fontSize', '36px');
      this.setStyle(clonedDoc, '.v-table .v-table__wrapper > table > tbody > tr > td', 'fontSize', '24px');
      this.setStyle(clonedDoc, '.v-table .v-table__wrapper > table > tbody > tr:not(.separator)', 'height', '48px');

      // html2canvas/1.4.1とjspdf/3.0.1で必要になった調整
      this.setStyle(clonedDoc, 'h1', 'paddingTop', '5px');
      this.setStyle(clonedDoc, 'h1', 'marginBottom', '-5px');
      this.setStyle(clonedDoc, '.v-table .v-table__wrapper > table > tbody > tr > td:not(.separator)', 'paddingTop', '9px');
      this.setStyle(clonedDoc, '.v-table .v-table__wrapper > table > tbody > tr > td:not(.separator)', 'paddingBottom', '2px');

      // PDFに出力した際に、リンクの下線とリンク文字列が重なる問題がある。
      // そのため、リンクではなく、通常のテキストとしてPDFへ出力する。
      this.setStyle(clonedDoc, 'a', 'text-decoration', 'none');
      this.setStyle(clonedDoc, 'a:link', 'color', 'inherit');
      this.setStyle(clonedDoc, 'a:visited', 'color', 'inherit');
    },

    setStyle: function (clonedDoc, selector, attr, val) {
      const forEach = Array.prototype.forEach;
      let items = clonedDoc.querySelectorAll(selector);
      forEach.call(items, function (element) {
        element.style[attr] = val;
      });
    },
  },
};
</script>
<style scoped>
.v-table .v-table__wrapper > table > tbody > tr > td.separator {
  height: 10px;
  background: aliceblue;
}
.container {
  width: 95%;
}
.v-overlay {
  align-items: center;
  justify-content: center;
}
.v-data-table :deep(th),
.v-data-table :deep(.v-data-table-footer) {
  font-size: 12px !important;
}
.v-data-table :deep(td) {
  font-size: 14px !important;
}
</style>
